<template>
    <v-container class="pa-0">
        <div v-if="isAuthor">
            <p class="text-h5">Apply Pricelist:</p>
            <div class="d-flex mb-4">
                <div style="width: 100%" @click="fetchPriceListNames()">
                    <v-autocomplete
                        v-model="selectedPriceListId"
                        class="mr-2"
                        :loading="loading"
                        :placeholder="`${loading ? 'Loading...' : ''}`"
                        :items="activePriceListIds"
                        outlined
                        :hide-details="true"
                        dense
                        :label="localize('selectPricelist')"
                    ></v-autocomplete>
                </div>

                <v-btn
                    :loading="applyBtnLoading"
                    @click="applyPriceListToCart()"
                    ><TranslatableStringComponent :tstring="{string: 'apply'}" /></v-btn
                >
            </div>
        </div>
        <v-tooltip v-if="shareableLink" top>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    text
                    class="pl-0"
                    color="primary"
                    v-bind="attrs"
                    style="text-transform: lowercase"
                    @click="handleClipboard()"
                    v-on="on"
                >
                    <div class="d-flex justify-space-between">
                        <span> {{ shareableLink }}</span>
                        <span>
                            <fa :icon="['fal', 'copy']" class="ml-4"
                        /></span>
                    </div>
                </v-btn>
            </template>
            <span><TranslatableStringComponent :tstring="{string: 'clickToCopy'}" /></span>
        </v-tooltip>
    </v-container>
</template>
<script>
import { mapState, mapGetters } from 'vuex'
import handleSnackbar from '~/mixins/handleSnackbar'
import TranslatableStringComponent from '~/components/TranslatableStringComponent.vue' 

export default {
    name: 'ShareablePanel',
    components: { TranslatableStringComponent },
    mixins: [handleSnackbar],
    data() {
        return {
            search: null,
            isEmailConfirmed: false,
            selectedPriceList: '',
            applyBtnLoading: false,
            loading: false,
        }
    },

    computed: {
        ...mapState('savedCarts', [
            'saveCartLoader',
            'isCartSaved',
            'currentSavedCartId',
            'isShareableLinkDisplayed',
        ]),
        ...mapState('priceList', [
            'activePriceListIds',
            'priceList',
            'appliedPriceList',
            'selectedPriceListId',
        ]),
        ...mapGetters({
            isCartEmpty: 'cart/isCartEmpty',
            isAuthor: 'auth/isAuthor',
            isSavedcartUpdated: 'savedCarts/isSavedcartUpdated',
            cartPriceList: 'priceList/cartPriceList',
        }),
        selectedPriceListId: {
            get() {
                return this.$store.state.priceList.selectedPriceListId
            },
            set(v) {
                this.$store.commit('priceList/setSelectedPriceListId', v)
            },
        },
        shareableLink() {
            return this.currentSavedCartId
                ? `${process.env.V2_BASE_URL}/cart?savedcartId=${this.currentSavedCartId}`
                : ''
        },
    },
    watch: {
        appliedPriceList(oldVal, newVal) {
            if (
                JSON.stringify(oldVal) !== JSON.stringify(newVal) &&
                newVal.length > 0 &&
                this.selectedPriceListId !== ''
            ) {
                this.hitSnackbar({ string: 'pricelistAlreadyApplied', variables: [
                        {
                            var: this.selectedPriceListId
                        }
                    ]},
                    ''
                )
            }
        },
    },
    methods: {
        clearCart() {
            this.$store.dispatch('cart/clearCart')
        },
        handleClipboard() {
            navigator.clipboard.writeText(this.shareableLink)
            this.hitSnackbar({string: 'linkCopiedSuccessfully'}, null)
        },
        async fetchPriceListNames() {
            if (this.activePriceListIds.length > 0) {
                return
            }
            this.loading = true
            await this.$store.dispatch('priceList/fetchPriceListNames')
            this.loading = false
        },
        async applyPriceListToCart() {
            if (
                this.selectedPriceListId === this.cartPriceList[0].PRICELISTID
            ) {
                this.hitSnackbar({string: 'pricelistAlreadyApplied', variables: [
                        {
                            var: this.selectedPriceListId
                        }
                    ]},
                    ''
                )
                return
            }
            this.applyBtnLoading = true
            await this.$store.dispatch('priceList/fetchAppliedPriceList')
            this.applyBtnLoading = false
        },
    },
}
</script>
